import moment from 'moment'

const dateFormatter = (key, value, model, record, translate) => {
    return moment(value).format("DD.MM.YYYY hh:mm:ss");
};



export default dateFormatter;